export default __webpack_public_path__ + "static/media/ambassador-bg.3157f44f.webp";